import { useEffect } from "react";
import { Route, Routes as Router, useLocation } from "react-router-dom";
import { Contribution } from "./pages/contribution/Contribution";
import { FbtVsPaye } from "./pages/fbt-vs-paye/FbtVsPaye";
import { GiftCard } from "./pages/gift-card/GiftCard";
import { Landing } from "./pages/landing/Landing";
import { extraordinaryColors } from "./utils/theme";

export const Routes = () => {
  const location = useLocation();

  // Handle BG color
  useEffect(() => {
    if (location.pathname === "/gift-card") {
      document.body.style.backgroundColor = extraordinaryColors.blue.light;
    } else if (location.pathname === "/fbt-vs-paye") {
      document.body.style.backgroundColor = extraordinaryColors.orange.main;
    } else if (location.pathname === "/contribution") {
      document.body.style.backgroundColor = extraordinaryColors.yellow.light;
    }

    return () => {
      document.body.style.backgroundColor = "";
    };
  }, [location]);

  return (
    <Router>
      <Route path="/" Component={Landing} />
      <Route path="/gift-card" Component={GiftCard} />
      <Route path="/fbt-vs-paye" Component={FbtVsPaye} />
      <Route path="/contribution" Component={Contribution} />
    </Router>
  );
};
